// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productImageCarouselStyles } from "@steiner/Overrides/Components/ProductImageCarousel";
import PlayCircle from "@steiner/XDL/Icons/PlayCircle";
import { color, hideElementOnPrint, xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

productImageCarouselStyles.illustrationMessage = {
    forwardAs: "p",
    size: 12,
    lineHeight: "15px",
    css: css`
        width: 100%;
        text-align: center;
        margin-bottom: 12px;

        ${hideElementOnPrint}
    `,
};

productImageCarouselStyles.carouselSlideInner = {
    css: css`
        width: 100%;
        height: 100%;
        text-align: center;
        position: relative;
        padding: 0 6px;
        display: flex;
        justify-content: center;
    `,
};

productImageCarouselStyles.mainContainer = {
    css: css`
        margin-top: 8px;
        ${xScreen("lt","sm")} {
            width: 430px;
            margin: 8px auto 0;
            max-width: 100%;
        }
    `,
};

productImageCarouselStyles.carouselGridItem = {};

productImageCarouselStyles.carouselOuterWrapper = {
    css: css`
        display: flex;
        flex-wrap: nowrap;
        width: 100%;
        position: relative;
        > div {
            width: 100%;
        }
    `,
};

productImageCarouselStyles.videoIcon = {
    src: PlayCircle,
    color: "common.black",
    size: 40,
    css: css`
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        & circle {
            fill: ${color("common.black")};
        }
        & polygon {
            fill: ${color("common.white")};
            color: ${color("common.white")};
        }
    `,
};

productImageCarouselStyles.prevArrowGridItem = {
    css: css`
        position: absolute;
        left: 0;
        height: 100%;
        background: linear-gradient(90deg, ${color("common.white", 1)} 0%, ${color("common.black", 0)} 100%);
        z-index: 1;
        pointer-events: none;
        &&& {
            width: 64px;
        }
    `,
};

productImageCarouselStyles.prevArrowButton = {
    variant: "secondary",
    color: "common.ui4",
    css: css`
        border: 0;
        padding: 0;
        height: 100%;
        pointer-events: auto;
    `,
};

productImageCarouselStyles.nextArrowGridItem = {
    css: css`
        position: absolute;
        right: 0;
        text-align: right;
        height: 100%;
        background: linear-gradient(90deg, ${color("common.black", 0)} 0%, ${color("common.white")} 100%);
        z-index: 1;
        pointer-events: none;
        &&& {
            width: 64px;
        }
    `,
};

productImageCarouselStyles.nextArrowButton = {
    variant: "secondary",
    color: "common.ui4",
    css: css`
        border: 0;
        padding: 0;
        height: 100%;
        pointer-events: auto;
    `,
};